$(document).ready(function () {
  $('.slider_product_global').slick({
    infinite: true,
    draggable: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  });

  $('.featured_in_slider').slick({
    slidesToShow: 5,
    arrows: false,
    settings: 'unslick',
    infinity: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: false,
          zIndex: 1,
          slidesToShow: 3,
          settings: 'slick',
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          zIndex: 1,
          slidesToShow: 2,
          arrows: false,
          settings: 'slick',
        },
      },
      {
        breakpoint: 568,
        settings: {
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          zIndex: 1,
          slidesToShow: 3,
          arrows: false,
          settings: 'slick',
        },
      },
    ],
  });

  console.log('du');
  $('.regular_two_colum_section_wrapper_content_slider').slick({
    slidesToShow: 1,
    arrows: false,
    swipe: false,
  });
  $('.regular_two_colum_section_wrapper_image_slider').slick({
    asNavFor: '.regular_two_colum_section_wrapper_content_slider',
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  });
  console.log('before init');
  console.log($('.slick-arrow'));
  $('.you_may_also_like_section_wrapper_slider').slick({
    slidesToShow: 3,
    autoplay: true,
    arrows: false,
    dots: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 968,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          zIndex: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 670,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          zIndex: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
  console.log('after init');
  console.log($('.slick-arrow'));

  $('.reviews_section_wrapper_slider').slick({
    slidesToShow: 3,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          zIndex: 1,
          slidesToShow: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 670,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          zIndex: 1,
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  });
});
